var map = {
	"./comission_desktop.svg": "0833",
	"./empty_desktop.svg": "0e49",
	"./filters_desktop.svg": "cb11",
	"./giftcard_desktop.svg": "10c0",
	"./investment_desktop.svg": "50d3",
	"./mkt_purchase_desktop.svg": "5c8e",
	"./mkt_sale_desktop.svg": "6d45",
	"./payment_desktop.svg": "ce80",
	"./refund_desktop.svg": "409b",
	"./topup_desktop.svg": "f5ff",
	"./voucher_desktop.svg": "4f17",
	"./withdraw_desktop.svg": "15cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0dbc";